import React, { Component } from 'react';
import { connect } from 'react-redux';
import { clickWidget } from '../../actions';
import { Link } from "react-router-dom";
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import {List, ListItem} from 'material-ui/List';
import Subheader from 'material-ui/Subheader';
import Divider from 'material-ui/Divider';
import locale from '../../common/locale'
import Cookies from 'universal-cookie';

const cookies = new Cookies();

export class UserRanking extends Component {

  render() {
    const { client, server, clickWidget } = this.props
    const ListItemStyle = { 'line-height': '7px', 'font-size': '14px', width: '200px'}

    if(server.userRanks.length === 0) {
      return( null )
    }
    const loc = cookies.get('locale')
    return(
      <div>
        <div className='UserRanking'
          style={{
            transform: `translate3d(
          ${client.x['r']}px,
          ${client.y['r']}px, 0px)`}}>

          <div onMouseDown={e => clickWidget(e, 'r') }
            style={{cursor: 'pointer'}}>
            <MuiThemeProvider>
              <List>
                <Subheader>{locale.user_ranking(loc)}</Subheader>
                <Divider />
                <ListItem style={ListItemStyle} containerElement={
                    <Link to={`/noders/${server.userRanks[0].name}`} />}>
                    <i className="fas fa-share-alt fa-lg r-icon" />
                    <div className='user'>　@{server.userRanks[0].name}</div>
                  {/* <div className='rank'>{server.userRanks[0].rank} p</div> */}
                </ListItem>
                <Divider />
                <ListItem style={ListItemStyle} containerElement={
                    <Link to={`/noders/${server.userRanks[1].name}`} />}>
                    <i className="fab fa-twitch fa-lg r-icon" />
                    <div className='user'>　@{server.userRanks[1].name}</div>
                </ListItem>
                <Divider />
                <ListItem style={ListItemStyle} containerElement={
                    <Link to={`/noders/${server.userRanks[2].name}`} />}>
                    <i className="fab fa-snapchat fa-lg r-icon" />
                  <div className='user'>　@{server.userRanks[2].name}</div>
                </ListItem>
                <Divider />
                <ListItem style={ListItemStyle} containerElement={
                    <Link to={`/noders/${server.userRanks[3].name}`} />}>
                    <i className="fab fa-angellist fa-lg r-icon" />
                  <div className='user'>　@{server.userRanks[3].name}</div>
                </ListItem>
                <Divider />
                <ListItem style={ListItemStyle} containerElement={
                    <Link to={`/noders/${server.userRanks[4].name}`} />}>
                    <i className="fab fa-github fa-lg r-icon" />
                  <div className='user'>　@{server.userRanks[4].name}</div>
                </ListItem>
                <Divider />
                <ListItem style={ListItemStyle} containerElement={
                    <Link to={`/noders/${server.userRanks[5].name}`} />}>
                    <i className="fab fa-mixcloud fa-lg r-icon" />
                  <div className='user'>　@{server.userRanks[5].name}</div>
                </ListItem>
                <Divider />
                <ListItem style={ListItemStyle} containerElement={
                    <Link to={`/noders/${server.userRanks[6].name}`} />}>
                    <i className="fab fa-reddit-alien fa-lg r-icon" />
                  <div className='user'>　@{server.userRanks[6].name}</div>
                </ListItem>
              </List>
            </MuiThemeProvider>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  client: state.client,
  server: state.server
});

const mapDispatchToProps = {
  clickWidget,
}

export default connect(mapStateToProps, mapDispatchToProps)(UserRanking)



// WEBPACK FOOTER //
// ./src/components/ranking/UserRanking.js